import { BankAccount, CreateInvoiceInput, Customer, Invoice } from '@thro-types/billing';

import { TFunction } from 'i18next';
import { pick } from 'lodash';
import * as yup from 'yup';

import { translations } from 'locales/i18n';

export const invoiceValidationSchema = (t: TFunction) =>
  yup.object().shape({
    bankAccount: yup.string().required(t(translations.validation.required())),
    // customer: yup.object().shape({
    //   address: yup.string().required(t(translations.validation.required())),
    //   city: yup.string().required(t(translations.validation.required())),
    //   companyName: yup.string().required(t(translations.validation.required())),
    //   country: yup.string().required(t(translations.validation.required())),
    //   createdAt: yup.date().required(t(translations.validation.required())),
    //   customerId: yup.string().required(t(translations.validation.required())),
    //   email: yup
    //     .string()
    //     .email(t(translations.validation.email()))
    //     .required(t(translations.validation.required())),
    //   firstName: yup.string(),
    //   id: yup.string().required(t(translations.validation.required())),
    //   isCurrentVersion: yup.boolean().required(t(translations.validation.required())),
    //   lastName: yup.string().required(t(translations.validation.required())),
    //   phone: yup.string().nullable(),
    //   updatedAt: yup.date().required(t(translations.validation.required())),
    //   zip: yup.string().required(t(translations.validation.required()))
    // }),
    customerVersionId: yup.string().required(t(translations.validation.required())),
    expertContact: yup.object().shape({
      firstName: yup.string().required(t(translations.validation.required())),
      lastName: yup.string().required(t(translations.validation.required())),
      email: yup
        .string()
        .email(t(translations.validation.email()))
        .required(t(translations.validation.required())),
      uid: yup.string().required(t(translations.validation.required()))
    }),
    paymentTarget: yup.string().required(t(translations.validation.required())),
    invoiceDate: yup.date().required(t(translations.validation.required()))
  });

export const invoiceInitialValues = (
  initialInvoice: Invoice | undefined
): Partial<CreateInvoiceInput & { customer?: Customer | string | null }> => {
  return initialInvoice
    ? {
        ...pick(initialInvoice, ['id', 'customer'])
      }
    : {
        customer: '',
        paymentTarget: '30d',
        bankAccount: BankAccount.STOK,
        invoiceDate: new Date()
      };
};
